import {NetworkFilter} from 'domain/usecases/private/guide-flow/medical-guide/get-network-filters';
import {QueryParamsEnum} from 'presentation/constants';
import {useQueryParams} from 'presentation/pages/private';
import {UseNetworkInputProps} from './types';

export function useNetworkInput({networkFilters, isLoading}: UseNetworkInputProps) {
	const {SEARCH_PARAMS, setSearchParams} = useQueryParams();
	const {networkType, serviceType} = SEARCH_PARAMS;

	const availableOptions = networkFilters;

	const isDisabled = isLoading || !serviceType || availableOptions.length === 0;

	const selectedDescription = () => {
		if (networkType) {
			const currentOpt = availableOptions.find(
				(opt: NetworkFilter) => opt.nome === networkType,
			);
			return currentOpt?.descricao.toUpperCase() || '';
		}
		return '';
	};

	const handleChange = (desc: string) => {
		const selected = availableOptions.find(
			(opt: NetworkFilter) => opt.descricao.toUpperCase() === desc.toUpperCase(),
		);

		if (selected) {
			setSearchParams(prev => {
				prev.set(QueryParamsEnum.NETWORK_TYPE, selected.nome);
				prev.set(QueryParamsEnum.NETWORK_CODE, String(selected.codigo));
				return prev;
			});
			return;
		}

		setSearchParams(prev => {
			prev.set(QueryParamsEnum.NETWORK_TYPE, '');
			prev.set(QueryParamsEnum.NETWORK_CODE, '');
			return prev;
		});
	};
	return {
		availableOptions,
		isDisabled,
		selectedDescription,
		handleChange,
		serviceType,
	};
}
